import { render, staticRenderFns } from "./ShowWidget.vue?vue&type=template&id=30447a22"
import script from "./ShowWidget.vue?vue&type=script&lang=js"
export * from "./ShowWidget.vue?vue&type=script&lang=js"
import style0 from "./ShowWidget.vue?vue&type=style&index=0&id=30447a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports